import { isProd } from "./env";

export const seeriAppDomain = isProd
  ? "https://seeri.store"
  : "https://seeri-app.dev.seeri.co";
